import { Pipe, PipeTransform } from "@angular/core";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { IStandardButtonDropdownItemConfig } from "src/standard/standard-button-dropdown/standard-button-dropdown.component";
import { IconDefinition } from "src/standard/standard-icon/standard-icon.component";

export function annotateActiveCode<
  TItem extends
    | IStandardButtonDropdownItemConfig
    | {
        icon?: IconDefinition;
        iconStyleClass?: string;
        code?: string;
      },
>(items: TItem[], code: string | null | undefined): TItem[];
// eslint-disable-next-line no-redeclare
export function annotateActiveCode<
  TItem extends
    | IStandardButtonDropdownItemConfig
    | {
        icon?: IconDefinition;
        iconStyleClass?: string;
        code?: string;
      },
>(items: null | undefined, code: string | null | undefined): undefined;
// eslint-disable-next-line no-redeclare
export function annotateActiveCode<
  TItem extends
    | IStandardButtonDropdownItemConfig
    | {
        icon?: IconDefinition;
        iconStyleClass?: string;
        code?: string;
      },
>(
  items: TItem[] | null | undefined,
  code: string | null | undefined,
): TItem[] | undefined;
// eslint-disable-next-line no-redeclare
export function annotateActiveCode<
  TItem extends
    | IStandardButtonDropdownItemConfig
    | {
        icon?: IconDefinition;
        iconStyleClass?: string;
        code?: string;
      },
>(
  items: TItem[] | null | undefined,
  code: string | null | undefined,
): TItem[] | undefined {
  if (!items || !code) {
    return items ?? undefined;
  }

  return items.map((x) => {
    const copy = { ...x };

    if ("code" in copy) {
      copy.icon = faCheck;

      if (code !== copy.code) {
        copy.iconStyleClass = "invisible";
      }
    }

    return copy;
  });
}

@Pipe({
  standalone: true,
  name: "annotateActiveCode",
})
export class AnnotateActiveCodePipe implements PipeTransform {
  transform<
    TItem extends
      | IStandardButtonDropdownItemConfig
      | {
          icon?: IconDefinition;
          iconStyleClass?: string;
          code?: string;
        },
  >(items: TItem[] | null | undefined, code: string | null | undefined) {
    return annotateActiveCode(items, code);
  }
}
